import { format, isValid, parse } from 'date-fns-modern';

import { TDSScheduleCityToCityRequestBody } from '@/apis/tds';

interface SearchRequestBodyDates {
  departDate: string | null | undefined;
  returnDate: string | null | undefined;
}

interface SearchRequestBodyFromTo {
  destination: string;
  origin: string;
}

interface SearchRequestBodyPassengerCounts {
  adult: number;
  child: number;
  senior: number;
}

const normalizeDate = (date: string | null | undefined): string | null => {
  if (!date) {
    return null;
  }
  let parsedDate = parse(date, 'MM/dd/yyyy', new Date());
  if (!isValid(parsedDate)) {
    parsedDate = parse(date, 'yyyy-MM-dd', new Date());
  }
  if (!isValid(parsedDate)) {
    return null;
  }
  return format(parsedDate, 'yyyy-MM-dd');
};

export const buildSearchRequestBody = (
  dates: SearchRequestBodyDates,
  fromTo: SearchRequestBodyFromTo,
  passengerCounts: SearchRequestBodyPassengerCounts,
  isReturn: boolean
): TDSScheduleCityToCityRequestBody => {
  const search = {
    departDate: normalizeDate(dates.departDate) ?? '',
    destinationCity: fromTo.destination,
    originCity: fromTo.origin,
    passengerCounts: {
      Adult: passengerCounts.adult,
      Child: passengerCounts.child,
      Military: 0,
      Senior: passengerCounts.senior,
      Student: 0
    },
    isReturn: isReturn,
    purchaseType: 'SCHEDULE_BOOK',
    returnDate: normalizeDate(dates.returnDate) ?? ''
  };
  return search;
};
